/**
 * 提现申请列表页面路径
 */
export const WITHDRAW_APPLY_LIST_PAGE_PATH = '/withdrawApply/list'
